export function useTabsClasses(line = false) {
  function getTabsContainerClasses() {
    let classes = ['tw-flex tw-items-center']
    if (line) {
      classes = ['tw-border-b', 'tw-border-b-solid', 'tw-border-grey-300']
    }
    return classes.concat(['tw-flex tw-items-center'])
  }

  function getContainerClass() {
    return ['tw-flex-col']
  }

  function getNavClasses() {
    return ['tw-gap-4', 'tw-w-full', line && 'tw-px-4'] // ctab for easy debugging
  }

  function getContentClasses() {
    return ['tw-mt-3']
  }

  function getSelectedTabClasses(variant: string) {
    const classes = ['tw-absolute', 'tw-left-0', 'tw-w-full']
    if (variant === 'primary') {
      classes.push('tw-bg-primary')
    } else {
      classes.push('tw-bg-sky')
    }

    if (line) {
      classes.push('tw-rounded-t tw-bottom-0 tw-h-1 line')
    } else {
      classes.push('tw-py-2 tw-px-3 tw-rounded-lg tw-top-0 tw-h-full pill')
    }

    return classes
  }

  function getTabClasses(
    isActive: boolean,
    isDisabled: boolean,
    variant: string,
    isFullWidth: boolean
  ) {
    function getVariantClasses() {
      switch (variant) {
        case 'secondary': {
          return {
            color: '!tw-text-blue-500',
            pillActiveColor: '!tw-text-white'
          }
        }
        case 'primary':
        default: {
          return {
            color: '!tw-text-primary-600',
            pillActiveBg: 'tw-bg-primary',
            pillActiveColor: '!tw-text-white'
          }
        }
        case 'info': {
          return {
            color: '!tw-text-blue-700',
            pillActiveColor: '!tw-text-white'
          }
        }
      }
    }

    const variantClasses = getVariantClasses()

    function pillTypeTabClasses() {
      let classes = [
        // Non-active pill
        'tw-whitespace-nowrap',
        'tw-px-3',
        'tw-py-2',
        'tw-font-medium',
        'tw-rounded-md',
        'hover:tw-bg-grey-300',
        'hover:tw-text-grey-600',
        'tw-text-base',
        'tw-text-grey-600'
      ]
      if (isActive) {
        // Active pill
        classes = [
          'tw-whitespace-nowrap',
          'tw-px-3',
          'tw-py-2',
          'tw-font-medium',
          'tw-rounded-md',
          'tw-text-base',
          'tw-font-semibold',
          variantClasses.pillActiveColor
        ]
      }
      if (isDisabled) {
        // Disabled pill
        classes = [
          'tw-px-3',
          'tw-py-2',
          'tw-font-medium',
          'tw-rounded-md',
          'tw-text-base',
          'tw-text-grey-300',
          'tw-bg-grey-300',
          'tw-text-grey-600',
          'tw-cursor-not-allowed'
        ]
      }
      if (isFullWidth) {
        return classes.concat('tw-flex-1 tw-w-full')
      }
      return classes.concat('tw-flex tw-items-center')
    }
    function lineTypeTabClasses() {
      // Line-type default tab
      let classes = [
        'tw-whitespace-nowrap',
        'tw-font-medium',
        'tw-text-base',
        'tw-transition-colors',
        'tw-text-grey-600',
        'tw-text-center',
        'tw-relative',
        'tw-px-3',
        'hover:tw-text-grey-600',
        'hover:tw-bg-grey-300',
        'hover:tw-rounded-t-lg'
      ]

      if (isActive) {
        // Line-type active tab
        classes = [
          'tw-whitespace-nowrap',
          'tw-font-medium',
          'tw-text-base',
          'tw-z-[2]',
          'tw-text-center',
          'tw-transition-colors',
          'tw-font-semibold',
          variantClasses.color,
          'tw-relative'
        ]
      }
      // Line-type disabled tab
      if (isDisabled) {
        classes = [
          'tw-whitespace-nowrap',
          'tw-font-medium',
          'tw-text-base',
          'tw-transition-colors',
          '!tw-text-grey-600',
          'tw-cursor-not-allowed',
          'tw-relative',
          'tw-px-3',
          'tw-bg-grey-300',
          'tw-rounded-t-lg'
        ]
      }
      if (isFullWidth) {
        return classes.concat('tw-flex-1')
      }
      return classes.concat('tw-flex tw-items-center tw-py-2 tw-px-3')
    }

    return line ? lineTypeTabClasses() : pillTypeTabClasses()
  }

  return {
    getTabClasses,
    getTabsContainerClasses,
    getContainerClass,
    getNavClasses,
    getContentClasses,
    getSelectedTabClasses
  }
}
